import { render, staticRenderFns } from "./add-items-template.vue?vue&type=template&id=2cf402e0"
import script from "./add-items-template.vue?vue&type=script&lang=js"
export * from "./add-items-template.vue?vue&type=script&lang=js"
import style0 from "./add-items-template.vue?vue&type=style&index=0&id=2cf402e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports